import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:8009', // URL base del backend
});

// Interceptor para incluir el token JWT automáticamente
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;

